import { useSelector, useDispatch } from 'react-redux'
import BaseModelsPopoverItem from './BaseModelsPopoverItem'
import { t } from '../../utils/i18n'
import {
  getBaseModel,
  getBatteryPrices,
  getSaddlePrices,
  listBaseModels,
  getTranslation
} from '../../utils/bike-schema'
import { formatCurrency } from '../../utils/money'
import { baseModelSet, bikeImageReload } from '../../actions'
import Popover from '../Popover'
import { BACKEND_URL } from '../../utils/settings'

const BaseModelsPopover = () => {
  const dispatch = useDispatch()
  const { bikeConfig, currencyCode, lang } = useSelector((state) => state)

  const titlesList = {
    da: [
      'Short John Budcykel',
      'Kopenhagen Classic',
      'Arrow Sport',
      'Arrow Classic',
      'Kopenhagen Balloon',
      'Vintage Racer',
      'Kopenhagen Fusion',
      'Børnecykler',
      'Ladcykel Med El (KUN ERHVERVSSALG)'
    ],
    en: [
      'Short John',
      'Kopenhagen Classic',
      'Arrow Sport',
      'Arrow Classic',
      'Kopenhagen Balloon',
      'Vintage Racer',
      'Kopenhagen Fusion',
      'Kids Bikes',
      'Electric cargo trike'
    ]
  }

  const currentId = bikeConfig.baseModelId
  const baseModels = listBaseModels()
    .filter(({ internal }) => !internal) // filter out internal models
    .map(({ id, name }) => ({
      baseModelId: id,
      name: getTranslation(name),
      active: currentId === id,
      imgUrl: `${BACKEND_URL}/bike-image?base_model_id=${id}&size=256x`
    }))

  baseModels.splice(22, 0, { hidden: true })
  baseModels.splice(22, 0, { hidden: true })

  const reducedData = baseModels.reduce((results, item, index) => {
    const groupId = Math.floor(index / 4)
    return {
      ...results,
      [groupId]: {
        ...(results[groupId] || {}),
        title: titlesList[lang][groupId],
        items: [
          ...((results[groupId] && results[groupId].items) || []),
          {
            ...item
          }
        ]
      }
    }
  }, {})

  const handleClick = (baseModelId) => {
    dispatch(baseModelSet(baseModelId))
    dispatch(bikeImageReload())
  }

  return (
    <Popover
      className="velorbis-customizer-gallery-popover velorbis-customizer-base-models-popover"
      minWidth={'250px'}
      alignTo={
        window.innerWidth > 768
          ? '.velorbis-customizer-header-base-model'
          : '.velorbis-customizer-header-base-model-mobile'
      }
      position="below"
    >
      <div className="velorbis-customizer-popover-header">
        {t('base_models_title')}
      </div>
      <div className="velorbis-customizer-popover-body velorbis-customizer-popover-body-no-padding velorbis-customizer-popover-body-scroll">
        {Object.keys(reducedData).map((key, index) => {
          const itemGroup = reducedData[key]
          if (itemGroup.items[0]?.baseModelId.startsWith('internal'))
            return null
          if (itemGroup.items[1]?.baseModelId.startsWith('internal'))
            return null
          return (
            <div
              className={`velorbis-customizer-gallery-popover-section${
                itemGroup.items.length > 2
                  ? ''
                  : ' velorbis-customizer-gallery-popover-section__half-width'
              }`}
              key={index}
            >
              <p className="velorbis-customizer-gallery-popover-section-name">
                {itemGroup.title}
              </p>
              {itemGroup.items.map((item) => {
                if (item.hidden) return null
                const baseModel = getBaseModel(item.baseModelId)
                const elechicBikeList = [
                  'arrow-classic-ladies',
                  'elechic-arrow-classic-ladies',
                  'kopenhagen-fusion-ladies',
                  'elechic-kopenhagen-fusion-gents',
                  'elechic-kopenhagen-fusion-ladies'
                ]
                const saddlePrice = elechicBikeList.find(
                  (element) => element === item.baseModelId
                )
                  ? getSaddlePrices()[currencyCode]
                  : 0
                const unitPrice = item.baseModelId.startsWith('elechic')
                  ? baseModel.prices[currencyCode] +
                    getBatteryPrices()[currencyCode]
                  : baseModel.prices[currencyCode] + saddlePrice
                const finalPrice = formatCurrency(unitPrice, currencyCode, true)
                return (
                  <BaseModelsPopoverItem
                    key={item.baseModelId}
                    baseModelId={item.baseModelId}
                    {...item}
                    onClick={() => handleClick(item.baseModelId)}
                    price={finalPrice}
                  />
                )
              })}
            </div>
          )
        })}
      </div>
    </Popover>
  )
}

export default BaseModelsPopover
